module.exports = __webpack_public_path__ + "static/media/user.ce41bd38.svg";